module.exports = __webpack_public_path__ + "static/favicon-574afe97c503af80e38ac7eb24a704db.png";